import React, { useEffect } from "react";
import { HEADING_FONTS, BODY_FONTS, ensureFontLoaded } from "../fonts";

// Grid of font swatches. Loads all fonts of the kind for live preview.
export default function FontPicker({ kind, value, onChange }) {
  const list = kind === "heading" ? HEADING_FONTS : BODY_FONTS;

  useEffect(() => {
    list.forEach(ensureFontLoaded);
  }, [list]);

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-3" data-testid={`font-picker-${kind}`}>
      {list.map((f) => {
        const selected = (value || "") === f.value;
        return (
          <button
            key={f.name}
            type="button"
            data-testid={`font-option-${kind}-${(f.value || "default").replace(/\s+/g, "-").toLowerCase()}`}
            onClick={() => onChange(f.value)}
            className={`border p-3 text-left transition-colors ${
              selected ? "border-primary bg-primary/10" : "border-border hover:border-primary"
            }`}
          >
            <p className="text-2xl text-foreground leading-none mb-2" style={{ fontFamily: f.stack }}>
              Aa
            </p>
            <p className="text-[0.65rem] tracking-wider text-muted-foreground">{f.name}</p>
          </button>
        );
      })}
    </div>
  );
}
